// Use /api/ routes for all environments
const API_BASE_URL = '/api';

const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  
  if (!response.ok) {
    if (contentType && contentType.includes('application/json')) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'An error occurred while processing your request');
    } else {
      throw new Error('Unable to connect to the server. Please try again later.');
    }
  }

  if (!contentType || !contentType.includes('application/json')) {
    throw new Error('Received an invalid response from the server');
  }

  return response.json();
};

export const fetchContactDetails = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/dynamicContactDetails`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching contact details:', error);
    throw error;
  }
};

export const fetchBlogs = async (limit = 10, offset = 0) => {
  try {
    const response = await fetch(`${API_BASE_URL}/getBlogs?limit=${limit}&offset=${offset}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch blogs');
    }

    return {
      blogs: data.blogs || [],
      blogCount: data.blogCount || 0
    };
  } catch (error) {
    console.error('Error fetching blogs:', error);
    throw error;
  }
};

export const fetchBlogById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/getBlogs/${id}`);
    return await handleResponse(response);
  } catch (error) {
    console.error('Error fetching blog by id:', error);
    throw new Error('Unable to load the blog post. Please try again later.');
  }
};

export const fetchProducts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/products`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/categories`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const fetchPopupMessages = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/popupMessages`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching popup messages:', error);
    throw error;
  }
};

export const fetchDirectors = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/directors`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching directors:', error);
    throw error;
  }
};

export const fetchPublications = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/publications`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching publications:', error);
    throw error;
  }
};

export const fetchMedia = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/media`);
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching media:', error);
    throw error;
  }
};

export const sendMessage = async (messageData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(messageData),
    });

    const data = await response.json();

    if (response.status === 201) {
      return { success: true, message: data.message };
    } else {
      throw new Error(data.error || 'Failed to send message');
    }
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const sendSuggestion = async (suggestionData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/suggestion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(suggestionData),
    });

    const data = await response.json();

    if (response.status === 201) {
      return { success: true, message: data.message };
    } else {
      throw new Error(data.error || 'Failed to submit suggestion');
    }
  } catch (error) {
    console.error('Error submitting suggestion:', error);
    throw error;
  }
};

export const fetchBlogPosts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/getBlogs`);
    return response.json();
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
}; 